import React from "react";
import { useTranslation } from "react-i18next";
import tw, { css } from "twin.macro";

import SearchIcon from "../../../static/icons/search.svg";
import ExpertSearchIcon from "../../../static/images/expert-search-icon.svg";
import SystemSearchIcon from "../../../static/images/system-search-icon.svg";
import Anchor from "../../components/Anchor";
import { BookMeeting } from "../../components/BookMeeting";
import Card from "../../components/Card";
import { Container } from "../../components/Container";
import { useContactUrl } from "../../utils/common";

const searchCards = css`
  ${tw`grid grid-cols-1 sm:grid-cols-2 mt-10 md:w-[50rem]`}
  >a:not(:first-of-type) {
    ${tw`pt-10 sm:pt-0`}
  }
  > a {
    ${tw`w-full p-0 text-turquoise w-full hover:(text-turquoise-dark) sm:max-w-[19.9rem]`}
    >div {
      ${tw`hover:shadow-xl motion-safe:hover:scale-105 h-full sm:mt-[50px] rounded-[4rem] max-h-[25rem]`}
    }
  }
  p,
  .cardContent {
    ${tw`mt-2 mb-2 text-xl`}
    >p {
      ${tw`mt-8`}
    }
    > div {
      > p {
        ${tw`flex inline-flex`}
      }
      > svg {
        ${tw`w-10 h-10 mx-auto mt-2`}
      }
    }
  }
  svg {
    ${tw`mx-auto fill-current`}
    >g {
      ${tw`stroke-current`}
    }
  }
`;

const SearchCards: React.FC = ({ ...rest }) => {
  const { t } = useTranslation();
  // System and expert search lived in the web app, which is shut down; these cards now lead to the contact page.
  const systemSearch = useContactUrl();
  const expertSearch = useContactUrl();

  return (
    <Container {...rest}>
      <section>
        <article>
          <h2>{t("index.searchButtons.header")}</h2>
          <span tw="bg-turquoise text-white border-solid border-black border text-2xl font-bold px-5 py-2 sm:text-3xl">
            {t("index.searchButtons.triangular")}
          </span>
          <p tw="mt-10 font-bold text-xl">{t("index.searchButtons.searchFor")}</p>
          <div css={searchCards}>
            <Anchor href={systemSearch}>
              <Card key={1} className="searchCard">
                <SystemSearchIcon tw="w-40 h-40" />
                <div tw="flex flex-col items-center w-auto">
                  <p tw="break-normal">{t("index.searchButtons.systems")}</p>
                  <SearchIcon tw="w-10 h-10" />
                </div>
              </Card>
            </Anchor>
            <Anchor href={expertSearch}>
              <Card key={2} className="searchCard">
                <ExpertSearchIcon tw="w-40 h-40" />
                <div tw="flex flex-col items-center">
                  <p tw="break-normal">{t("index.searchButtons.experts")}</p>
                  <SearchIcon tw="w-10 h-10" />
                </div>
              </Card>
            </Anchor>
          </div>

          <p tw="mt-10 sm:mt-20 text-xl">{t("index.searchButtons.materialDeveloper")}</p>
          <p tw="mt-10 font-black text-2xl sm:text-4xl">{t("index.searchButtons.outro")}</p>
          <BookMeeting commentFirst={true} />
        </article>
      </section>
    </Container>
  );
};

export default SearchCards;
